/**
 * user_type：
 * developer
 * manager 管理員
 * admin 行政
 * tutor 導師
 * clerk 文員
 * student
 */

function _getCannotAccessList(config) {
  let _cannotAccessList = {
    // 繳交學費
    'PayTuitionList': ['tutor', 'student'],
    'PayTuitionList_T21': ['admin', 'tutor', 'student'],
    'PayTuitionPayment': ['tutor', 'student'],
    'PayTuitionPayment_T21': ['admin', 'tutor', 'student'],
    // 調堂要求
    'SwitchRequirement': ['tutor', 'clerk', 'student'],
    'SwitchRequirement_T21': ['admin', 'tutor', 'clerk', 'student'],
    'SwitchRequirement_T38': ['admin', 'tutor', 'clerk', 'student'],
    'StudentSwitchRequirement': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    // 課程時間表
    'Timetable': ['student'],
    'Timetable_T21': ['admin', 'student'],
    'CreateClass': ['tutor', 'student'],
    'CreateClass_T21': ['admin', 'tutor', 'student'],
    'CreateClass_T38': ['student'],
    'ClassDetails': ['student'],
    'ClassDetails_T21': ['admin', 'student'],
    //學生管理
    'StudentList': ['tutor', 'student'],
    'StudentDetails': ['student'],
    'StudentDetails_T38': ['tutor', 'student'],
    'StudentUserDetails': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    'CreateStudent': ['tutor', 'student'],
    'StudentAttendance': ['tutor', 'student'],
    'StudentUserAttendance': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    'StudentPoints': ['tutor', 'student'],
    'StudentUserPoints': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    //課程管理 / 線上課程
    'CourseList': ['tutor', 'clerk', 'student'],
    'CourseList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CourseDetails': ['tutor', 'clerk', 'student'],
    'CourseDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateCourse': ['tutor', 'clerk', 'student'],
    'CreateCourse_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CourseCategoryList': ['tutor', 'clerk', 'student'],
    'CourseCategoryList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateCourseCategory': ['tutor', 'clerk', 'student'],
    'CreateCourseCategory_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CourseCategoryDetails': ['tutor', 'clerk', 'student'],
    'CourseCategoryDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    //組別管理
    'GradeSetting': ['tutor', 'clerk', 'student'],
    'GradeSetting_T21': ['admin', 'tutor', 'clerk', 'student'],
    //訂單紀錄
    'OrderList': ['tutor', 'student'],
    'StudentUserOrderList': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    //商品管理
    'ProductList': ['tutor', 'clerk', 'student'],
    'ProductList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ProductList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'ProductDetails': ['tutor', 'clerk', 'student'],
    'ProductDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ProductDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateProduct': ['tutor', 'clerk', 'student'],
    'CreateProduct_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateProduct_T38': ['admin', 'tutor', 'clerk', 'student'],
    'ProductCategoryList': ['tutor', 'clerk', 'student'],
    'ProductCategoryList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ProductCategoryList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateProductCategory': ['tutor', 'clerk', 'student'],
    'CreateProductCategory_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateProductCategory_T38': ['admin', 'tutor', 'clerk', 'student'],
    'ProductCategoryDetails': ['tutor', 'clerk', 'student'],
    'ProductCategoryDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ProductCategoryDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    //套票管理
    'PackageList': ['tutor', 'clerk', 'student'],
    'PackageList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'PackageList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'PackageDetails': ['tutor', 'clerk', 'student'],
    'PackageDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'PackageDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreatePackage': ['tutor', 'clerk', 'student'],
    'CreatePackage_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreatePackage_T38': ['admin', 'tutor', 'clerk', 'student'],
    //月票管理
    'MonthPassList': ['tutor', 'clerk', 'student'],
    'MonthPassList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'MonthPassList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'MonthPassDetails': ['tutor', 'clerk', 'student'],
    'MonthPassDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'MonthPassDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateMonthPass': ['tutor', 'clerk', 'student'],
    'CreateMonthPass_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateMonthPass_T38': ['admin', 'tutor', 'clerk', 'student'],
    //分校管理
    'SchoolList': ['tutor', 'clerk', 'student'],
    'SchoolList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'SchoolList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'SchoolList_T60': ['admin', 'tutor', 'clerk', 'student'],
    'SchoolDetails': ['tutor', 'clerk', 'student'],
    'SchoolDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'SchoolDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'SchoolDetails_T60': ['admin', 'tutor', 'clerk', 'student'],
    'CreateSchool': ['tutor', 'clerk', 'student'],
    'CreateSchool_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateSchool_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateSchool_T46': ['admin', 'tutor', 'clerk', 'student'],
    'CreateSchool_T60': ['admin', 'tutor', 'clerk', 'student'],
    //課室管理
    'ClassroomList': ['tutor', 'clerk', 'student'],
    'ClassroomList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ClassroomList_T38': ['admin', 'clerk', 'student'],
    'ClassroomDetails': ['tutor', 'clerk', 'student'],
    'ClassroomDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'ClassroomDetails_T38': ['admin', 'clerk', 'student'],
    'CreateClassroom': ['tutor', 'clerk', 'student'],
    'CreateClassroom_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateClassroom_T38': ['admin', 'clerk', 'student'],
    //導師管理
    'TutorList': ['tutor', 'clerk', 'student'],
    'TutorList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'TutorDetails': ['tutor', 'clerk', 'student'],
    'TutorDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateTutor': ['tutor', 'clerk', 'student'],
    'CreateTutor_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateTutor_T46': ['admin', 'tutor', 'clerk', 'student'],
    'SalaryReport': ['tutor', 'clerk', 'student'],
    'SalaryReport_T38': ['admin', 'tutor', 'clerk', 'student'],
    'TutorCalendar': ['tutor', 'clerk', 'student'],
    'TutorCalendar_T38': ['admin', 'tutor', 'clerk', 'student'],
    'TutorLeave': ['tutor', 'clerk', 'student'],
    'TutorUserLeave': ['developer', 'manager', 'admin', 'clerk', 'student'],
    // 推廣活動
    'CouponList': ['tutor', 'clerk', 'student'],
    'CouponList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CouponDetails': ['tutor', 'clerk', 'student'],
    'CouponDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateCoupon': ['tutor', 'clerk', 'student'],
    'CreateCoupon_T21': ['admin', 'tutor', 'clerk', 'student'],
    // 推送通知
    'NotifyList': ['tutor', 'clerk', 'student'],
    'NotifyList_T21': ['admin', 'tutor', 'clerk', 'student'],
    'NotifyList_T38': ['admin', 'tutor', 'clerk', 'student'],
    'NotifyDetails': ['tutor', 'clerk', 'student'],
    'NotifyDetails_T21': ['admin', 'tutor', 'clerk', 'student'],
    'NotifyDetails_T38': ['admin', 'tutor', 'clerk', 'student'],
    'CreateNotify': ['tutor', 'clerk', 'student'],
    'CreateNotify_T21': ['admin', 'tutor', 'clerk', 'student'],
    'CreateNotify_T38': ['admin', 'tutor', 'clerk', 'student'],
    //Blog
    'BlogCategoryList': ['tutor', 'clerk', 'student'],
    'BlogCategoryDetails': ['tutor', 'clerk', 'student'],
    'CreateBlogCategory': ['tutor', 'clerk', 'student'],
    'BlogList': ['tutor', 'clerk', 'student'],
    'BlogDetails': ['tutor', 'clerk', 'student'],
    'CreateBlog': ['tutor', 'clerk', 'student'],
    'StudentBlogList': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    'StudentBlogDetails': ['developer', 'manager', 'admin', 'tutor', 'clerk'],
    //教學影片
    'VideoCategoryList': ['tutor', 'clerk', 'student'],
    'VideoCategoryDetails': ['tutor', 'clerk', 'student'],
    'CreateVideoCategory': ['tutor', 'clerk', 'student'],
    'VideoList': ['tutor', 'clerk', 'student'],
    'VideoDetails': ['tutor', 'clerk', 'student'],
    'CreateVideo': ['tutor', 'clerk', 'student'],
    // 設定
    'Setting': ['tutor', 'clerk', 'student'],
    'Setting_T21': ['admin', 'tutor', 'clerk', 'student'],
    'Setting_T38': ['admin', 'tutor', 'clerk', 'student'],
    // 報表
    'Report': ['tutor', 'clerk', 'student'],
    'Report_T38': ['admin', 'tutor', 'clerk', 'student'],
    // 查詢
    'Enquiry': ['tutor', 'clerk', 'student'],
    // action
    'editStudent': ['tutor'],
    'upgradeStudent': ['tutor', 'student'], // 學生升級
    'quitAndRemissStudent': ['tutor', 'student'], // 學生退學/重新入學
    'blockStudent': ['tutor', 'student'], // 學生 限制登入/解除登入限制
    'blockStaff': ['admin', 'tutor', 'clerk', 'student'], // Staff 限制登入/解除登入限制
    'advancedEditOrder': ['tutor', 'student'], // 作廢發票/審核付款/退款
    'editOrder': ['tutor', 'student'], // 修改訂單
    'canAuditReq': ['tutor', 'clerk', 'student'], // 調堂要求 (接受/拒絕)
    'editClass': ['tutor', 'student'], // update 課堂資訊, 課程其他課堂
    'editClass_T38': ['student'],
    'editClass_T30': ['student'],
    'editAttendance': ['student'], // update 學生出席狀態
    'editStudentPoints': ['tutor', 'student'], // 新增/扣減積分
    'viewSalary': ['admin', 'tutor', 'clerk', 'student'], // view 導師薪酬 related
    'viewSalary_T46': ['tutor', 'clerk', 'student'],
    'viewSalary_T60': ['tutor', 'clerk', 'student'],
    'canAuditLeave': ['tutor', 'clerk', 'student'], // 請假申請 (接受/拒絕) / 導師attendance
    'viewLog': ['tutor', 'clerk', 'student'], // view Log Record
  }
  let _cannotAccessList_dup = JSON.parse(JSON.stringify(_cannotAccessList));
  for (let key in _cannotAccessList_dup) {
    if (_cannotAccessList_dup[`${key}_${config.VUE_APP_RUN_MODE}`] !== undefined) {
      _cannotAccessList[key] = _cannotAccessList_dup[`${key}_${config.VUE_APP_RUN_MODE}`];

      if (_cannotAccessList[`${key}_${config.VUE_APP_RUN_MODE}`] !== undefined) {
        delete _cannotAccessList[`${key}_${config.VUE_APP_RUN_MODE}`];
      }
    }
  }

  return _cannotAccessList;
}
function _getDefaultPages(config) {
  const _cannotAccessList = _getCannotAccessList(config);
  const defaultPageList = ['PayTuitionList', 'SwitchRequirement', 'Timetable', 'TutorUserLeave', 'StudentList', 'StudentUserDetails', 'StudentSwitchRequirement', 'StudentUserAttendance', 'StudentUserOrderList', 'CourseCategoryList', 'GradeSetting', 'OnlineCourseCategoryList', 'OrderList', 'ProductList', 'PackageList', 'MonthPassList', 'SchoolList', 'ClassroomList', 'TutorList', 'CouponList', 'NotifyList', 'BlogCategoryList', 'VideoCategoryList', 'WebsiteHomeSetting', 'AboutUs', 'StudentBlogList', 'BasicSetting', 'Report'];
  const _defaultPages = {
    developer: [],
    manager: [],
    admin: [],
    tutor: [],
    student: [],
    clerk: [],
  };
  for (let type in _defaultPages) {
    let list = JSON.parse(JSON.stringify(defaultPageList));
    for (let i = list.length - 1; i >= 0; i--) {
      if (_cannotAccessList[defaultPageList[i]] && _cannotAccessList[defaultPageList[i]].includes(type)) {
        list.splice(i, 1);
      }
    }
    _defaultPages[type] = list;
  }
  return _defaultPages;
}

function _getUserTypeGrade(config) {
  const userTypeGrade = {
    developer: ['manager', 'admin', 'tutor', 'clerk'],
    manager: ['manager', 'admin', 'tutor', 'clerk'],
    admin: ['admin', 'tutor', 'clerk'],
    tutor: ['tutor'],
    clerk: ['clerk'],
  }

  if (config.VUE_APP_RUN_MODE === 'T60') {
    userTypeGrade['admin'] = ['tutor', 'clerk'];
  }

  return userTypeGrade;
}

export const getCannotAccessList = _getCannotAccessList;
export const getDefaultPages = _getDefaultPages;
export const getUserTypeGrade = _getUserTypeGrade;

